// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__yY0hL","tyre":"style_tyre__Srs+x"};